import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const IMKey = 'imId'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getImId() {
  return Cookies.get(IMKey)
}

export function setImId(imId) {
  return Cookies.set(IMKey, imId)
}

export function removeImId() {
  return Cookies.remove(IMKey)
}
